import { useAuthStore } from '@/stores/auth';
import { LogOut } from 'lucide-react';
import { useNavigate } from '@tanstack/react-router';
import { useEmployeeNameFormatter } from '@/lib/employee-name';

export function ImpersonationBanner() {
  const { user, isImpersonating, exitImpersonation } = useAuthStore();
  const navigate = useNavigate();
  const formatName = useEmployeeNameFormatter();

  if (!isImpersonating || !user) return null;

  const displayName = user.employee
    ? formatName({ firstName: user.employee.firstName, lastName: user.employee.lastName })
    : user.email;

  const handleExit = async () => {
    await exitImpersonation();
    navigate({ to: '/people' });
  };

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] flex h-9 items-center justify-between bg-amber-500 px-4 text-sm font-medium text-amber-950">
      <div className="flex items-center gap-2">
        <span>
          Viewing as <strong>{displayName}</strong>
          <span className="ml-1 opacity-75">&middot; {user.role}</span>
        </span>
      </div>
      <button
        onClick={handleExit}
        className="inline-flex items-center gap-1.5 rounded-md bg-amber-950/15 px-3 py-1 text-xs font-semibold transition-colors hover:bg-amber-950/25"
      >
        <LogOut className="h-3 w-3" />
        Exit
      </button>
    </div>
  );
}
